"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const OptionGroup_vue_1 = __importDefault(require("./OptionGroup.vue"));
const Options_vue_1 = __importDefault(require("./Options.vue"));
const SearchBox_vue_1 = __importDefault(require("./SearchBox.vue"));
const SelectedOption_vue_1 = __importDefault(require("./SelectedOption.vue"));
let MultiSelect = class MultiSelect extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.selectedOption = null;
        this.selectedOptions = [];
        this.filteredOptions = [];
        this.filteredGroups = [];
        this.isActive = false;
    }
    get availableOptions() {
        return this.filteredOptions.filter((option) => {
            return this.selectedOptions.indexOf(option) === -1;
        });
    }
    get availableGroupedOptions() {
        let options = [];
        this.filteredGroups.forEach((group) => {
            options.push({
                label: group.label,
                options: group.options.filter((option) => {
                    return this.selectedOptions.indexOf(option) === -1;
                })
            });
        });
        return options;
    }
    get inputPlaceholder() {
        if (this.selectedOption !== null
            && this.multipleOptions === false) {
            return this.selectedOption.label;
        }
        if (this.placeholder === "") {
            return "Select an option";
        }
        return this.placeholder;
    }
    get optionsSelected() {
        if (this.selectedOption !== null
            || this.selectedOptions.length > 0) {
            return true;
        }
        return false;
    }
    get searchPlaceholder() {
        if (this.entity === "") {
            return "Search";
        }
        return `Search by ${this.entity}`;
    }
    mounted() {
        this.updateSearch("");
    }
    selectOption(option) {
        this.isActive = false;
        if (this.multipleOptions === true) {
            this.selectedOptions.push(option);
            this.$emit('updated', this.selectedOptions);
            return;
        }
        this.selectedOption = option;
        this.$emit('updated', this.selectedOption);
    }
    toggleMultiSelect() {
        if (this.disabled) {
            return;
        }
        this.isActive = !this.isActive ? true : false;
        // Reset the search query
        this.updateSearch("");
        // Check if the dropdown overflows the page
        if (this.isActive) {
            this.checkDropdownOverflow();
        }
    }
    deactivate() {
        this.isActive = false;
        // Reset the search query
        this.updateSearch("");
    }
    checkDropdownOverflow() {
        this.$nextTick(() => {
            const dropdown = this.$refs.dropDown;
            const bounds = dropdown.getBoundingClientRect();
            const overflow = (bounds.y + bounds.height) - window.innerHeight;
            const remValue = 16;
            if (overflow > 0) {
                dropdown.style.height = bounds.height - (overflow + remValue) + 'px';
            }
        });
    }
    deleteOption(deletedOption) {
        this.selectedOptions = this.selectedOptions.filter((option) => {
            return option !== deletedOption;
        });
        this.$emit('updated', this.selectedOptions);
    }
    updateSearch(query) {
        if (this.groups.length > 0) {
            this.filteredGroups = this.filterGroups(query);
            return;
        }
        this.filteredOptions = this.filterOptions(this.options, query);
    }
    filterGroups(query) {
        let filteredGroups = [];
        this.groups.forEach((group) => {
            filteredGroups.push(Object.assign(Object.assign({}, group), { options: this.filterOptions(group.options, query) }));
        });
        return filteredGroups;
    }
    filterOptions(options, query) {
        if (query === "") {
            return options;
        }
        let filteredOptions = [];
        options.forEach((option) => {
            let lowercaseValue = option.label.toLowerCase();
            if (option.label.indexOf(query) != -1
                || lowercaseValue.indexOf(query) != -1) {
                filteredOptions.push(option);
            }
        });
        return filteredOptions;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ default: () => [] })
], MultiSelect.prototype, "options", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: "Label" })
], MultiSelect.prototype, "label", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: "" })
], MultiSelect.prototype, "placeholder", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: "" })
], MultiSelect.prototype, "entity", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: "" })
], MultiSelect.prototype, "validationLabel", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: "" })
], MultiSelect.prototype, "helperMessage", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: false })
], MultiSelect.prototype, "multipleOptions", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: false })
], MultiSelect.prototype, "searchable", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: false })
], MultiSelect.prototype, "disabled", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: true })
], MultiSelect.prototype, "valid", void 0);
__decorate([
    vue_property_decorator_1.Prop({ default: () => [] })
], MultiSelect.prototype, "groups", void 0);
MultiSelect = __decorate([
    vue_property_decorator_1.Component({
        components: {
            OptionGroup: OptionGroup_vue_1.default,
            Options: Options_vue_1.default,
            SearchBox: SearchBox_vue_1.default,
            SelectedOption: SelectedOption_vue_1.default
        }
    })
], MultiSelect);
exports.default = MultiSelect;
